import {
  actions,
  selectFirstTimeSlot,
  selectFlow,
  selectTotalQuantity,
  useAppDispatch,
  useAppSelector,
} from '../store';
import { Flow } from '../services/viva/constants';

import type { Availability } from '../components/BuyTickets/SegmentedTimePicker/Availabilities';
import type { ComboPerformance } from '../store/types';

/**
 * @description
 * This hook is used to select a time slot from the segmented time picker.
 *
 * @param setLocalPerformanceAK - This is used to set the performance AK local to
 * the component that is using this hook.
 *
 **/
export const useSelectTimeSlot = (
  setLocalPerformanceAK?: React.Dispatch<React.SetStateAction<string>>,
) => {
  const dispatch = useAppDispatch();
  const flow = useAppSelector(selectFlow);
  const combo = useAppSelector((state) => state.order.combo);
  const shopCartTimeSlots = useAppSelector(
    (state) => state.order.shopCart.timeSlot,
  );
  const selectedTimeSlot = useAppSelector(selectFirstTimeSlot);
  const checkoutTotalQuantity = useAppSelector(selectTotalQuantity);

  const selectTimeSlot = (timeSlot: Availability) => {
    const { ak, start } = timeSlot;
    let timeSlots: Availability[] = [];

    if (ak === selectedTimeSlot?.ak) return;

    // Check if the time slot has enough availability
    if (Number(timeSlot.availability) < checkoutTotalQuantity) {
      return;
    }

    setLocalPerformanceAK?.(ak);

    // Rock Pass has two time slots, so we need to update both
    if ([Flow.RC_ROCK_PASS].includes(flow)) {
      timeSlots = [...(shopCartTimeSlots ?? [])];
      timeSlots[combo.comboIndex] = timeSlot;
    } else {
      timeSlots = [timeSlot];
    }

    dispatch(actions.order.setPriceTableAK(timeSlot.priceTableAK));

    dispatch(actions.order.setShopCartSelectionsTimeSlots(timeSlots));
    dispatch(actions.order.updateShopCartTimeSlots(timeSlot));

    const performances = {
      [flow]: [`${ak}`],
    } as { [key in Flow]: string[] };

    const comboPerformance: ComboPerformance = {
      time: start,
      performanceAK: ak,
    };

    dispatch(actions.order.setComboPerformances(comboPerformance));
    dispatch(actions.order.setPerformances({ data: performances, flow }));
  };

  return selectTimeSlot;
};
